import React from "react";
import Card from "../Card/Card";

const data = [
  {
    year: "2025",
    url: "/CAASIM/actas-de-baja-documental/Dictamen de Baja Documental AGE-SEA-DBDTS-275-278-284-2025.pdf",
    document:
      "Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-275-278-284-2025",
  },
  {
    year: "2023",
    url: "/CAASIM/actas-de-baja-documental/Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-152-2023.pdf",
    document:
      "Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-152-2023",
  },
  {
    year: "2022",
    url: "/CAASIM/actas-de-baja-documental/Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-043-2022.pdf",
    document:
      "Dictamen de Baja Documental y-o Transferencia Secundaria AGE-SEA-DBDTS-043-2022",
  },
  {
    year: "2018",
    url: "/CAASIM/actas-de-baja-documental/Dictamen de Baja Documental y-o Transferencia Secundaria SEA-OR-DVS-277-2018.pdf",
    document:
      "Dictamen de Baja Documental y-o Transferencia Secundaria SEA-OR-DVS-277-2018",
  },
];

function ActasBajaDocumental() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title">
          DICTAMEN DE BAJA DOCUMENTAL Y/O TRANSFERENCIA SECUNDARIA
        </h3>
        <hr className="hr-gob" />
      </div>
      <div className="row">
        {data.map((programa, index) => (
          <Card
            key={index}
            document={programa.document}
            href={programa.url}
            year={programa.year}
            type={"PDF"}
          />
        ))}
      </div>
    </div>
  );
}

export default ActasBajaDocumental;
